<div class="container" style="margin-top: 100px;">

        <div class="row justify-content-center">
                <div class="col-sm-6">
                        <h2 class="h2">Login now to access the portal and get the most out of it</h2>
                        <h4 class="display-1 text-center bg-primary"
                                style="border:1px solid grey;border-radius: 10px;line-height: 50px;color:white">Log In
                        </h4>
                        <div class="form-group">
                                <form [formGroup]="profileForm" (ngSubmit)="login()">
                                        <div class="form-group">
                                                <label class="form-group" for="Email">Email: </label>
                                                <input type="email" formControlName="Email" id="Email"
                                                        class="form-control mb-3" placeholder="Enter your email" />
                                                <div *ngIf="Email.invalid && (Email.dirty || Email.touched)"
                                                        class="alert alert-danger">
                                                        <div *ngIf="Email.errors.required">
                                                                Email is required.
                                                        </div>
                                                        <div *ngIf="Email.errors.email">
                                                                Email should be valid.
                                                        </div>
                                                        <div *ngIf="Email.errors.minlength">
                                                                Email must be at least 4 characters long.
                                                        </div>
                                                </div>
                                        </div>
                                        <div class="form-group">
                                                <label class="form-group" for="password">Password: </label>
                                                <input type="password" formControlName="password"
                                                        class="form-control mb-3" placeholder="Enter your password">
                                                <div *ngIf="password.invalid && (password.dirty || password.touched)"
                                                        class="alert alert-danger">
                                                        <div *ngIf="password.errors.required">
                                                                Password is required.
                                                        </div>
                                                </div>
                                        </div>
                                        <div style="color:red" *ngIf="loginConfirm==false">Please enter a valid
                                                credentials</div>
                                        <br> <button type="submit" class="btn btn-primary"
                                                [disabled]="!profileForm.valid">Login</button>
                                </form>
                        </div><br>
                        <p>Don't have an account? <a routerLink="/signup">Sign up now</a></p>

                </div>